const Divider = () => <div className="bg-gray-200 h-px my-3" />;

export default Divider;
